// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"354bc067","239":"0d6a6380","453":"78b3aab1","455":"f409fb88"}[chunkId] + ".chunk.js";
};